import type { HTMLAttributes } from 'react';

import { cx, variantClass } from './styles';

const badgeTones = {
  neutral: 'bg-surface-hover text-text-muted',
  accent: 'bg-accent/10 text-accent-text',
  success: 'bg-success/10 text-success-text',
  warning: 'bg-warning/10 text-warning-text',
  danger: 'bg-danger/10 text-danger-text',
  info: 'bg-info/10 text-info-text'
} as const;

export type BadgeTone = keyof typeof badgeTones;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({ className, tone = 'neutral', ...props }: BadgeProps) {
  return (
    <span
      {...props}
      className={cx(
        'kitsune-optical-py-1 inline-flex w-fit items-center gap-1 rounded-sm px-2',
        'text-xs font-medium',
        variantClass(badgeTones, tone),
        className
      )}
    />
  );
}
